// extracted by mini-css-extract-plugin
export default {"video":"HomePage_video__ERqRf"};